/**
 * Visual state for pathway call footer subtitles (qai-subtitles kind).
 * Values match the expected strings for the @qai/ui subtitles component.
 */
export enum SubtitleKind {
  Ready = 'ready',
  Speaking = 'speaking',
  Listening = 'listening',
  Muted = 'muted',
  Thinking = 'thinking',
}
